// window.WEB_URL=process.env.BASE_API_URL; TODO
window.WEB_URL=process.env.NODE_ENV != 'production'?"https://inspectqp.eyoungroup.cn":"https://inspectqp.eyoungroup.cn";
window.UPLOAD_URL = WEB_URL+"/upload"




//////////////////
// WEBPACK FOOTER
// ./config/global.js
// module id = 5N5f
// module chunks = 128